import { defineComponent as y, useSlots as S, computed as d, openBlock as l, createBlock as c, resolveDynamicComponent as _, normalizeClass as f, withCtx as g, createElementBlock as o, renderSlot as t, createElementVNode as m, createCommentVNode as s, toDisplayString as i, createTextVNode as u } from "vue";
import { CardSlimVariant as r } from "./novoui-vuejs65.js";
import k from "./novoui-vuejs12.js";
const v = {
  key: 0,
  class: "card-slim-media-container"
}, I = {
  key: 1,
  class: "card-slim-media-container"
}, $ = ["src"], C = { class: "card-slim-body" }, w = {
  key: 0,
  class: "card-slim-eyebrow"
}, B = { class: "card-slim-headline" }, V = {
  key: 0,
  class: "card-slim-subheader"
}, N = {
  key: 3,
  class: "card-slim-slot"
}, z = {
  key: 4,
  class: "card-slim-trailing-icon"
}, D = {
  key: 6,
  class: "card-slim-footer"
}, q = /* @__PURE__ */ y({
  __name: "NCardSlim",
  props: {
    variant: { default: r.elevated },
    headline: { default: "Headline" },
    subheader: { default: "Subheader" },
    eyebrow: { default: "" },
    footer: {},
    mediaIcon: {},
    mediaIconBackground: {},
    mediaImage: {},
    trailingIcon: {},
    onClick: {},
    link: { default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  setup(h) {
    const e = h;
    S();
    const n = d(() => e.link ? "a" : e.onClick ? "button" : "div"), b = d(() => {
      let a = "";
      switch (e.variant) {
        case r.elevated:
          a = "card-slim-elevated";
          break;
        case r.outline:
          a = "card-slim-outline";
          break;
        case r.fill:
          a = "";
          break;
      }
      return a;
    }), p = d(() => e.mediaIconBackground);
    return (a, E) => (l(), c(_(n.value), {
      href: e.link && n.value === "a" ? e.link : null,
      onClick: e.onClick,
      disabled: n.value === "button" && e.disabled,
      class: f([
        "card-slim",
        "card-slim-clickable",
        b.value,
        {
          "card-slim-has-footer": a.$slots.footerSlot || e.footer,
          "card-slim-multi-column": a.$slots.footerSlot && a.$slots.default,
          "card-slim-disabled": e.disabled
        }
      ])
    }, {
      default: g(() => [
        a.$slots.mediaSlot ? (l(), o("div", v, [
          t(a.$slots, "mediaSlot")
        ])) : e.mediaImage ? (l(), o("div", I, [
          m("img", {
            class: "card-slim-media",
            src: e.mediaImage
          }, null, 8, $)
        ])) : e.mediaIcon ? (l(), c(k, {
          key: 2,
          class: f(["card-slim-circle-icon", p.value]),
          icon: e.mediaIcon,
          size: 24
        }, null, 8, ["class", "icon"])) : s("", !0),
        m("span", C, [
          e.eyebrow ? (l(), o("p", w, i(e.eyebrow), 1)) : s("", !0),
          m("h5", B, i(e.headline), 1),
          t(a.$slots, "subheaderSlot", {}, () => [
            !e.eyebrow && e.subheader ? (l(), o("p", V, i(e.subheader), 1)) : s("", !0)
          ])
        ]),
        a.$slots.default ? (l(), o("div", N, [
          t(a.$slots, "default", {}, () => [
            u("DefaultSlot")
          ])
        ])) : s("", !0),
        a.$slots.trailingIconSlot ? (l(), o("span", z, [
          t(a.$slots, "trailingIconSlot", {}, () => [
            u("IconSlot")
          ])
        ])) : e.trailingIcon ? (l(), c(k, {
          key: 5,
          class: "card-slim-trailing-icon",
          icon: e.trailingIcon,
          size: 24
        }, null, 8, ["icon"])) : s("", !0),
        a.$slots.footerSlot || e.footer ? (l(), o("span", D, [
          t(a.$slots, "footerSlot", {}, () => [
            u(i(e.footer), 1)
          ])
        ])) : s("", !0)
      ]),
      _: 3
    }, 8, ["href", "onClick", "disabled", "class"]));
  }
});
export {
  q as default
};
